import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { isNil } from 'lodash-es';
import { EFilterType, EStrategy, IFilterDateRangeOption, IFilterParams } from '../filter.type';

type IDate = [Date | null, Date | null];

@Component({
  selector: 'bixi-filter-advance-date-range',
  template: `
    <nz-form-item>
      <nz-form-label [nzSpan]="5">{{ option.title }}</nz-form-label>
      <nz-form-control [nzSpan]="19">
        <nz-date-picker
          [nzFormat]="option.format"
          [nzShowTime]="option.showTime"
          [nzShowToday]="option.showToday"
          [nzDisabled]="option.disabled"
          [(ngModel)]="_date[0]"
          (ngModelChange)="onStartDateChange()"
        ></nz-date-picker>
        ~
        <nz-date-picker
          [nzFormat]="option.format"
          [nzShowTime]="option.showTime"
          [nzShowToday]="option.showToday"
          [nzDisabled]="option.disabled"
          [(ngModel)]="_date[1]"
          (ngModelChange)="onEndDateChange()"
        ></nz-date-picker>
      </nz-form-control>
    </nz-form-item>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterAdvanceDateRangeComponent implements OnChanges {
  _date: IDate = [null, null];
  @Input() option: IFilterDateRangeOption;
  @Input() filterParams: IFilterParams;
  @Output() valueChange = new EventEmitter<{ mode: EStrategy; type: EFilterType; value: IDate }>();

  onStartDateChange() {
    this.onDateChange();
  }

  onEndDateChange() {
    this.onDateChange();
  }

  onDateChange() {
    this.valueChange.emit({ mode: EStrategy.normal, type: EFilterType.dateRange, value: this._date as IDate });
  }

  ngOnChanges(changes: SimpleChanges) {
    const { filterParams } = changes;
    if (filterParams) {
      if (isNil(filterParams.currentValue[this.option.key])) {
        this._date = [null, null];
      } else {
        this._date = filterParams.currentValue[this.option.key];
      }
    }
  }
}
